import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faReact, faCode, '', faCogs, '', faShoppingCart, faDatabase, faTerminal, faHtml5, faCss3Alt, faJs, faPython, faPhp, faWordpress, faBootstrap, faTailwindcss, faJquery, faGit, faGithub, faVscode } from '@fortawesome/free-brands-svg-icons';
import colorSharp from "../assets/img/color-sharp.png";
import { motion } from 'framer-motion';
import { useState } from 'react';

export const Experience = () => {
  const [activeTab, setActiveTab] = useState('languages');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const skillCategories = {
    languages: [
      { name: 'C/C++', icon: '' },
      { name: 'Python', icon: '' },
      { name: 'JavaScript', icon: '' },
      { name: 'GoLang', icon: '' },
      { name: 'Rust', icon: '' },

      { name: 'Solidity', icon: '' },
      { name: 'Sway', icon: '' },
      { name: 'Cairo', icon: '' },
      { name: 'Latex', icon: '' },



    ],
    technologies: [
      { name: 'DeFi', icon: '' },
      { name: 'Aave', icon: '' },
      { name: 'Compound', icon: '' },
      { name: 'Ethereum', icon: '' },
      { name: 'Solana', icon: '' },
      { name: 'ERC20', icon: '' },
      { name: 'ERC721', icon: '' },
      { name: 'ERC1155', icon: '' },
      { name: 'Truffle', icon: '' },
      { name: 'Hardhat', icon: '' },
      { name: 'Ganache', icon: '' },
      { name: 'DApps', icon: '' },
      { name: 'Foundry', icon: '' },
      { name: 'Anvil', icon: '' },

    ],
    libraries: [
      { name: 'C++ STL', icon: '' },
      { name: 'React', icon: '' },
      { name: 'Uniswap V2/V3', icon: '' },
      { name: 'Pancake.sol', icon: '' },
    ],
    webDevTools: [
      { name: 'VSCode', icon: '' },
      { name: 'Git', icon: '' },
      { name: 'GitHub', icon: ''},
      { name: 'ExpressJS', icon: '' },
      { name: 'NodeJS', icon: '' },
     
  
    ],
    frameworks: [
      { name: 'Bootstrap', icon: '' },
      { name: 'Tailwind CSS', icon: '' },
   
    ],
    cloudDatabases: [
      { name: 'Relational Databases (MySQL)', icon: '' },
      { name: 'MongoDb', icon: '' },
      { name: 'PostgreSQL', icon: '' },
      { name: 'MySQL', icon: '' },

    ],
 
  };

  return (
    <section className="skills-section" id="skills">
      <style jsx>{`
        .skills-section {
          padding: 50px 0;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5));
          position: relative;
          overflow: hidden;
        }
        .skills-section h2 {
          color: #fff;
          margin-bottom: 20px;
          text-align: center;
          font-size: 1.8rem; /* Larger font size for headings */
        }
        .tabs {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 20px;
        }
        .tab {
          background: #333;
          border: 1px solid #555;
          padding: 10px 20px;
          margin: 5px;
          border-radius: 5px;
          cursor: pointer;
          color: #fff;
          transition: background 0.3s, color 0.3s;
          font-size: 1rem; /* Font size for tabs */
        }
        .tab.active, .tab:hover {
          background: #555;
          color: #ddd;
        }
        .skills-content {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
        }
        .skill-category {
          background: #444;
          padding: 20px;
          border-radius: 10px;
          margin: 10px;
          width: calc(50% - 20px); /* 2 items per row with some spacing */
          max-width: 300px; /* Max width for larger screens */
          text-align: center;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .skill-category:hover {
          transform: scale(1.05);
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
        }
        .skill-category h3 {
          color: #fff;
          margin-bottom: 10px;
          font-size: 1.2rem; /* Font size for skill names */
        }
        .skill-category ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .skill-category ul li {
          margin-bottom: 10px;
          color: #ccc;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.9rem; /* Font size for skill list items */
        }
        .skill-category ul li .icon {
          margin-right: 10px;
          color: #ffd700;
        }
        .background-image-left {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0.1;
          z-index: -1;
        }

        /* Responsive Styles */
        @media (max-width: 768px) {
          .tab {
            padding: 8px 16px;
            font-size: 0.9rem;
          }
          .skill-category {
            width: calc(100% - 20px); /* Full width with some margin */
          }
          .skills-section h2 {
            font-size: 1.5rem;
          }
        }
        @media (max-width: 480px) {
          .tab {
            padding: 6px 12px;
            font-size: 0.8rem;
          }
          .skill-category {
            width: calc(100% - 20px); /* Full width for mobile devices */
            padding: 15px;
          }
          .skills-section h2 {
            font-size: 1.2rem;
          }
        }
      `}</style>
      <div className="container">
        <h2>Technical Skills & Interests</h2>
        <div className="tabs">
          {Object.keys(skillCategories).map((category) => (
            <div
              key={category}
              className={`tab ${activeTab === category ? 'active' : ''}`}
              onClick={() => handleTabChange(category)}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </div>
          ))}
        </div>
        <motion.div
          className="skills-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {skillCategories[activeTab].map((skill) => (
            <div key={skill.name} className="skill-category">
              <FontAwesomeIcon icon={skill.icon} size="3x" className="icon" />
              <h3>{skill.name}</h3>
              <ul>
                <li>{skill.name}</li>
              </ul>
            </div>
          ))}
        </motion.div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="background" />
    </section>
  );
};
